import { route } from 'preact-router';
import { useState, useEffect } from 'preact/hooks';
import useApp from '../context/AppContext';
import { useToaster } from '../context/ToasterContext';
import FormEvent from '../components/ui/FormEvent';
import Input from '../components/ui/Input';
import useEvent from '../hooks/useEvent';
import { getRemainingDays } from '../functions';
import { updateAnimal, addEventType, updateEventType, findEventsType } from '../api/api';

export default function FormEventOther(_route) {
    const { isDataLoaded, animals, config, events, categories, eventsType, setAnimals, setEventsType } = useApp();
    if (!isDataLoaded) {
        return (
            <div class="text-center">
                <div class="spinner-border text-warning" role="status">
                    <span class="visually-hidden">Loading data ...</span>
                </div>
            </div>
        );
    }
    const addToast = useToaster();
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
    const { getEventInfo, saveEvent } = useEvent();
    let isEventType = typeof _route.type_id != "undefined";
    let isEditEventType = typeof _route.edit_type_id != "undefined";
    let event_type_name = null;
    const [eventInfo, setEventInfo] = useState(getEventInfo(_route, animals, events));
    let selectedAnimals = eventInfo.selectedAnimals;
    eventInfo.event?.categoryId && (eventInfo.categoryId = eventInfo.event.categoryId);
    eventInfo.event?.wt_meat && (eventInfo.wt_meat =  eventInfo.event.wt_meat);
    eventInfo.event?.wt_milk && (eventInfo.wt_milk = eventInfo.event.wt_milk);
    eventInfo.isCreateEvent = typeof _route.id == "undefined" || _route.id == "";
    eventInfo.isUnique = _route.animal_id;

    if (isEventType || isEditEventType) {
        eventInfo.isCreateEvent = false;
        let typeId = isEventType ? _route.type_id : _route.edit_type_id;
        let eventType = eventsType.find(evt => evt.id == typeId);
        if (eventType) {
            const eventTypeData = JSON.parse(eventType.data);
            event_type_name = eventType.name;
            eventInfo.date = eventTypeData.date;
            eventInfo.notes = eventTypeData.notes;
            eventInfo.categoryId = eventTypeData.category ? eventTypeData.category.replace('/api/categories/', '') : "";
            eventInfo.wt_meat = eventTypeData.wtMeat;
            eventInfo.wt_milk = eventTypeData.wtMilk;
        }
        else {
            eventInfo.date = "";
        }
        // Do not display selected animals when editing an event type
        if (isEditEventType) {
            selectedAnimals = [];
            eventInfo.selectedAnimals = [];
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function addCategory() {
        route('/form-category')
    }

    function maxWaitingTime(wt_date, wt_meat, wt_milk, animalId) {
        const animalEvents = events.filter((_event) => _event.animalId == animalId);
        const animalEventsOther = animalEvents.filter((_event) => _event.type == 4);
        let allWtMeat = [];
        let allWtMilk = [];
        allWtMeat.push(getRemainingDays(wt_date, wt_meat));
        allWtMilk.push(getRemainingDays(wt_date, wt_milk));
        animalEventsOther.map(_event => {
            // if we are modifying the event don't use the previous value
            if (!_route || !_route.id || _route.id != _event.id) {
                allWtMeat.push(getRemainingDays(_event.dateApi, _event.wt_meat));
                allWtMilk.push(getRemainingDays(_event.dateApi, _event.wt_milk));
            }
        });
        return { meat: Math.max(...allWtMeat), milk: Math.max(...allWtMilk) };
    }

    async function manageEventType(eventTypeId, eventTypeName, formEvent) {
        let ok = true;
        const data = {
            name: eventTypeName,
            data: JSON.stringify(formEvent)
        }
        if (eventTypeId == "") {
            await addEventType(data)
                .then(() => {
                    addToast('success', 'Evènement type ajouté');
                })
                .catch(err => {
                    addToast('danger', 'Erreur lors de l ajout de l evt type : ' + error.toString());
                    ok = false;
                })
        } else {
            await updateEventType(data, eventTypeId)
                .then(() => {
                    addToast('success', 'Evènement type mis à jour');
                })
                .catch(err => {
                    addToast('danger', 'Erreur lors de la mise à jour de l evt type : ' + error.toString());
                    ok = false;
                })
        } 
        return ok;
    }

    function handleSubmit(e) {
        e.preventDefault();
        e.returnValue = '';
        let error = 0;
        const fields = e.target;
        const formEvent = {
            category: fields.categoryId.value ? "/api/categories/" + fields.categoryId.value : null,
            date: fields.date.value,
            notes: fields.notes.value,
            type: 4,
            wtMeat: parseInt(fields.wt_meat.value),
            wtMilk: parseInt(fields.wt_milk.value),
            wtDate: (fields.wt_meat.value > 0 || fields.wt_milk.value > 0) ? fields.date.value : null
        }
        // If we are editing an event type
        if (isEditEventType) {
            manageEventType(_route.edit_type_id, fields.event_type_name.value, formEvent).then(resp => {
                if (resp) {
                    findEventsType()
                        .then(evtsType => {
                            setEventsType(evtsType);
                            route('/events-type-list');
                        })
                        .catch(err => {
                            addToast('danger', 'Impossible de récupérer les evts type : ' + err.message);
                        });
                }
                setSubmitButtonDisabled(false);
            });
            return;
        }

        if (fields.date.value == '') {
            addToast('warning', 'Vous devez fournir une date.');
            return;
        }
        setSubmitButtonDisabled(true);
        
        // Save the event for all animals
        saveEvent(selectedAnimals, formEvent, false, _route).then(responses => {
            responses.map(response => {
                addToast(response.type, response.message);
                if (response.type != 'success') error++;
            })
        });
        // For each animal, save the animal with computed wt_meat and wt_milk but not the event
        selectedAnimals.map((animal, idx) => {
            let maxWT = maxWaitingTime(
                fields.date.value,
                parseInt(fields.wt_meat.value),
                parseInt(fields.wt_milk.value),
                animal.id);
            let formAnimal = {
                wtMeat: maxWT.meat,
                wtMilk: maxWT.milk,
                wtDate: new Date().toDateInputValue()
            };
            // Special cases, to be moved on a function
            if (fields.categoryId.value == config.weanedCategory) {
                // wean the animal(sevrage)
                formAnimal.weaned = true;
                // Set mother followed -1 if the children is weaned 
                let mother = animals.find(m => m.id == animal.motherId);
                console.log('Mother followed', mother.followed);
                if (mother) {
                    const formMother = {
                        followed: mother.followed - 1
                    }
                    // Update the mother followed value in case of twins
                    let motherIndex = animals.findIndex(m => m.id == animal.motherId);
                    animals[motherIndex].followed = mother.followed - 1;
                    // Update the animal in the store
                    updateAnimal(formMother, animal.motherId).then(response => {
                        if (response["@context"] && response["@context"] == '/api/contexts/Error') {
                            animals[motherIndex].followed = mother.followed;
                            addToast('danger', 'Erreur lors de la mise à jour de la mère: ' + response["hydra:description"]);
                        } else {
                            addToast('success', 'Mère (' + animal.motherName + ') mise à jour');
                        }
                    }).catch(error => {
                        addToast('danger', 'Erreur lors de la mise à jour de la mère : ' + error.toString());
                    });
                }
            }
            if (fields.categoryId.value == config.driedupCategory) {
                // Set driedup to true (tarissement)
                formAnimal.driedup = true;
            }
            // Save the event and refresh data (refresh only if it's the last animal)
            let refresh = selectedAnimals.length == idx + 1;
            saveEvent([animal], false, formAnimal, _route, refresh).then(responses => {
                responses.map(response => {
                    addToast(response.type, response.message);
                    if (response.type != 'success') error++;
                })
                setSubmitButtonDisabled(false);
            });
        });
        if (error == 0) history.go(-1);
    }

    return (
        <FormEvent title={isEditEventType ? "Autre évènement (type)" : "Autre évènement "} 
            onSubmit={handleSubmit}
            eventInfo={eventInfo}
            message=""
            submitButtonDisabled={submitButtonDisabled}
            setEventInfo={setEventInfo}
            >
            {(isEditEventType) && <Input id="event_type_name" label="Nom de l'évènement" type="text" value={event_type_name} />}
            <div class="container text-center">
                <div class="row">
                    <div class="col-10 ps-0 pe-0">
                        <div class="form-floating  mb-3">
                            <select class="form-control" id="categoryId" name="categoryId" value={eventInfo.categoryId}>
                                <option value="">- Aucune -</option>
                                {
                                    categories.map((cat) => {
                                        return (
                                            <option key={cat.id} value={cat.id}>{cat.name}</option>
                                        )
                                    })
                                }
                            </select>
                            <label class="form-label" for="category">Catégorie</label>
                        </div>
                    </div>
                    <div class="col-2 pe-0 pt-2">
                        <input class="btn btn-secondary" type="button" value="+" onClick={addCategory} />
                    </div>
                </div>
            </div>
            <Input id="wt_meat" label="T.A. Viande" type="text" value={eventInfo.wt_meat} />
            <Input id="wt_milk" label="T.A. Lait" type="text" value={eventInfo.wt_milk} />
        </FormEvent>
    );
}